import { Icon } from '@components/atoms/Icon';
import { IconType } from '@src/types/IconType';
import { classNames } from '@utils/classNames.ts';

type InfoProps = {
  onClick?: () => void;
  className?: string;
};

export const Info = ({ onClick, className }: InfoProps) => {
  return (
    <button
      data-testid="info"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      className="print:hidden"
    >
      <Icon
        type={IconType.Information}
        className={classNames(
          'h-[18px] w-[18px] text-ivarioBlue ',
          className ?? '',
        )}
      />
    </button>
  );
};
